<template>
    <div class="success-form">
        <span class="alert-success">Mensagem enviada com sucesso, obrigado!</span>
        <p>Dados da sua solicitação:</p>
        <ul>
            <li>
                <div class="data-section">
                    <span class="title">Assunto:</span>
                    <span class="message-content">{{ this.formStatus.data.get('assunto') }}</span>
                </div>
            </li>
            <li>
                <div class="data-section">
                    <span class="title">Nome:</span>
                    <span class="message-content">{{ this.formStatus.data.get('nome') }}</span>
                </div>
            </li>
            <li>
                <div class="data-section">
                    <span class="title">E-mail:</span>
                    <span class="message-content">{{ this.formStatus.data.get('email') }}</span>
                </div>
            </li>
            <li>
                <div class="data-section">
                    <span class="title">Número do Pedido:</span>
                    <span class="message-content">{{ this.formStatus.data.get('pedido') }}</span>
                </div>
            </li>
            <li>
                <div class="data-section">
                    <span class="title">Mensagem:</span>
                    <span class="message-content">{{
                        this.formStatus.data.get('comentario')
                    }}</span>
                </div>
            </li>
        </ul>
        <button class="btn" id="btn-return-form" @click="returnToForm">Voltar</button>
    </div>
</template>

<script>
    export default {
        name: 'SuccessFormMessage',
        props: {
            returnToForm: {
                type: Function,
                default: () => {},
            },
            formStatus: {
                type: Object,
                default: {},
            },
        },
    };
</script>
